import { render, staticRenderFns } from "./BankCardType.vue?vue&type=template&id=1c4d5354&scoped=true"
import script from "./BankCardType.vue?vue&type=script&lang=js"
export * from "./BankCardType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d5354",
  null
  
)

export default component.exports